import { ApolloError } from '@apollo/client';

import { useApiGatewayQuery } from '~hooks';
import { GET_HUBPRODUCTS } from '~queries';
import {
  GetHubProductsQuery,
  GetHubProductsQueryVariables,
  HubProduct,
} from '~types/appsync.types';

const useHubProductList = (): [HubProduct[], boolean, ApolloError | undefined] => {
  const { loading, error, data } = useApiGatewayQuery<
    GetHubProductsQuery,
    GetHubProductsQueryVariables
  >(GET_HUBPRODUCTS);

  const filteredProducts = data?.hubProducts.filter((hubProduct) => hubProduct.listing !== null);

  return [filteredProducts ?? [], loading, error];
};

export default useHubProductList;
